import "@brivity/ai-components/dist/style.css";
import PropTypes from "prop-types";
import { AiComponentsProvider } from "@brivity/ai-components";
import { getAiToken } from "@shared/externalApi";
import { useAiAssistApiUrl } from "../../reducers/layoutReducer/selectors";

function AiProvider({ children }) {
  const apiUrl = useAiAssistApiUrl();
  return (
    <AiComponentsProvider
      fetchToken={() => getAiToken().then(({ token }) => token)}
      apiUrl={apiUrl}
      theme={document.body.classList.contains("place-theme") ? "ai-place" : "ai-brivity"}
    >
      {children}
    </AiComponentsProvider>
  );
}

AiProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AiProvider;
